import { render, staticRenderFns } from "./UserBlock.vue?vue&type=template&id=4954d2e8&scoped=true&"
import script from "./UserBlock.vue?vue&type=script&lang=js&"
export * from "./UserBlock.vue?vue&type=script&lang=js&"
import style0 from "./UserBlock.vue?vue&type=style&index=0&id=4954d2e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4954d2e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4954d2e8')) {
      api.createRecord('4954d2e8', component.options)
    } else {
      api.reload('4954d2e8', component.options)
    }
    module.hot.accept("./UserBlock.vue?vue&type=template&id=4954d2e8&scoped=true&", function () {
      api.rerender('4954d2e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/General/Sidebar/UserBlock.vue"
export default component.exports